import React, { useState } from "react";
import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogTitle, TextField, Typography } from "@mui/material";

interface DialogCancelarTarefaProps {
  open: boolean;
  handleClose: () => void;
  handleOK: (motivo: string) => void;
  isLoading: boolean;
}

export default function DialogCancelarTarefa({
  open,
  handleClose,
  handleOK,
  isLoading
}: DialogCancelarTarefaProps) {
  const [motivoCancelamento, setMotivoCancelamento] = useState("");

  const handleCancelar = () => {
    setMotivoCancelamento("");
    handleClose();
  };

  return (
    <Dialog open={open} onClose={handleClose}>
      <DialogTitle>Devolver Tarefa</DialogTitle>
      <DialogContent>
        <Typography variant="subtitle2" gutterBottom>
          Sua tarefa atual será devolvida, e o processo retornará ao responsável anterior.
        </Typography>

        <TextField
          autoFocus
          margin="dense"
          id="motivo-cancelamento"
          label="Motivo da devolução"
          type="text"
          fullWidth
          multiline
          rows={4}
          value={motivoCancelamento}
          onChange={(e) => setMotivoCancelamento(e.target.value)}
        />
      </DialogContent>

      <DialogActions>
        <Button onClick={handleCancelar} color="primary">
          Cancelar
        </Button>

        <Button disabled={isLoading} variant="contained" onClick={() => handleOK(motivoCancelamento)} color="error">
          {isLoading && <CircularProgress size={20} sx={{ mr: 1 }} />}
          Confirmar
        </Button>
      </DialogActions>
    </Dialog>
  );
}
